import { I as t } from "../../iconLoader.gen-j5fU8Wkg.js";
function o(r) {
  return typeof r == "string" && r in t;
}
export {
  o as isIconName
};
